<div id="ht">
  <div id="main-cnt">
    <ion-header class="main-header block">
      <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
          <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()"><span class="path1"></span><span class="path2"></span></span>
              <ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
              <span class="breadcrumb">AMMINISTRATORE - SQUADRE</span>
          </div>
        </ion-buttons>
        <div slot="end" class="notification-div">
          <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
            <img [src]="sessionService?.user?.profileImg|s3Link" />
          </ion-avatar>
        </div>
        <app-add-bookmark slot="end" pageTitle="Squadre" url="/teams"></app-add-bookmark>

      </ion-toolbar>
      <br /><!-- edit da qui... -->
      <div class="flex-collapsible">
        <div class="flex-row header" (click)="showFilters = !showFilters">
          <div class="flex-1 text-center">
            <img
              class="svg-white vertical-middle xsmall"
              src="./assets/imgs/search.svg"
            />Ricerca<img
              class="svg-white vertical-middle xsmall"
              src="./assets/imgs/filter.svg"
            />
          </div>
        </div>
        <div class="panel" *ngIf="showFilters">
          <div style="text-align: center; padding: 1rem">
            <input
              [(ngModel)]="filters.name"
              name="name"
              class="text-input full-width block"
              placeholder="Ricerca per capo squadra"
              type="search"
              (keyup)="filterUsers()"
            />
          </div>
        </div>
      </div>
      <h3 class="panel-title">Teams</h3>
      <!-- ...a qui --></ion-header
    >
    <ion-content class="main-content">
      <div class="scroller-container">
        <div class="content-scroller">
          <div class="content teams-page">
            <!-- edit da qui... -->
            <!-- <div class="flex-row"> <div class="flex-grid-3"> <div (click)="openTeam(user.id)" class="tiny-card user center-content glass-blurred-background drop-shadow text-center" *ngFor="let user of teamList; let i=index;"> <img class="space-below svg-white list-avatar" src="./assets/imgs/avatar.svg"> <div class="ellipsis">{{ user.name }}</div> <div class="ellipsis">Manager: {{ user.manager?.name }} {{ user.manager?.lastname }}</div> </div> </div> </div> -->
            <!-- esempio di come sarebbe la struttura finale (da astrarre in component) -->
            <!-- dobbiamo però decidere la struttura dell'array che mi arriverà dell'api, dato che ci possono essere infiniti livelli di nesting (e le performance potrebbero peggiorare) -->
            <!-- -->
            <!-- Per far funzionare l'explode, bisogna assicurarsi che ogni <li> abbia un "id" unico. Al momento sto usando una combinazione di team.id + indice del loop, ma ovviamente servirebbe qualcosa di piu solido -->
            <!-- livello 1 -->

            <ul>
              <ng-template #recursiveList let-list>
                <li
                  *ngFor="let team of list; let i=index;"
                  (click)="openTeam($event, team.id)"
                  [id]="'itm1' + '-' + team.id "
                  class="collapsed"
                >
                  <div
                    class="list-item-block team-item glass-blurred-background drop-shadow"
                  >
                    <img
                      class="pic svg-white list-avatar"
                      src="./assets/imgs/avatar.svg"
                    />
                    <div class="name center-content-vertical">
                      {{ team.name|titlecase }} {{team.lastname|titlecase}}
                    </div>
                    <div class="caret" *ngIf="team.nextNode.length != 0">
                      <img
                        class="svg-white vertical-middle xsmall down"
                        src="./assets/imgs/caret-down.svg"
                        (click)="collapse($event, 'itm1' + '-' + team.id )"
                      /><img
                        class="svg-white vertical-middle xsmall right"
                        src="./assets/imgs/caret-right.svg"
                        (click)="expand($event, 'itm1' + '-' + team.id )"
                      />
                    </div>
                  </div>
                  <ul *ngIf="team.nextNode.length >0">
                    <ng-container
                      *ngTemplateOutlet="recursiveList;context:{$implicit: team.nextNode}"
                    ></ng-container>
                  </ul>
                </li>
              </ng-template>
              <ng-container
                *ngTemplateOutlet="recursiveList; context:{ $implicit: teamList }"
              ></ng-container>
            </ul>
          </div>
        </div>
      </div>
    </ion-content>
  </div>
</div>
